var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPromos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.12595 11.3851C9.59186 11.3851 9.96955 11.0074 9.96955 10.5415C9.96955 10.0756 9.59186 9.69788 9.12595 9.69788C8.66004 9.69788 8.28235 10.0756 8.28235 10.5415C8.28235 11.0074 8.66004 11.3851 9.12595 11.3851Z",
    fill: "url(#paint0_linear_61_102)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7484 9.21392L15.98 5.09542C15.7874 4.73344 15.4971 4.43282 15.142 4.22783C14.7869 4.02284 14.3814 3.92173 13.9717 3.93602L9.52067 4.46372C9.14967 4.47662 8.78806 4.5837 8.46984 4.77487C8.15163 4.96604 7.88728 5.23503 7.70167 5.55652L3.29347 13.1917C3.00334 13.6943 2.92473 14.2916 3.07495 14.8522C3.22516 15.4128 3.59189 15.8907 4.09447 16.1809L10.3145 19.7718C10.8171 20.062 11.4144 20.1406 11.9749 19.9904C12.5355 19.8402 13.0134 19.4734 13.3036 18.9708L17.7118 11.3356C17.8973 11.0141 17.9981 10.6507 18.0045 10.2795C18.0109 9.90834 17.9227 9.54165 17.7484 9.21392ZM14.4812 5.37232C14.7134 5.50639 14.9007 5.70631 15.0193 5.9468C15.1379 6.1873 15.1825 6.45757 15.1475 6.72343C15.1126 6.98929 14.9995 7.2388 14.8227 7.44042C14.6459 7.64204 14.4133 7.7867 14.1543 7.85611C13.8953 7.92552 13.6215 7.91656 13.3676 7.83037C13.1136 7.74418 12.891 7.58463 12.7277 7.37189C12.5645 7.15915 12.468 6.90278 12.4504 6.6352C12.4329 6.36762 12.4951 6.10085 12.6292 5.86862C12.809 5.55722 13.1051 5.33 13.4524 5.23692C13.7997 5.14385 14.1698 5.19255 14.4812 5.37232ZM7.95177 9.86352C8.08584 9.63129 8.28576 9.44402 8.52625 9.32541C8.76675 9.2068 9.03702 9.16216 9.30288 9.19715C9.56874 9.23214 9.81826 9.34519 10.0199 9.52199C10.2215 9.69878 10.3661 9.9314 10.4356 10.1904C10.505 10.4494 10.496 10.7232 10.4098 10.9771C10.3236 11.2311 10.1641 11.4537 9.95134 11.617C9.73861 11.7802 9.48224 11.8767 9.21466 11.8943C8.94708 11.9118 8.6803 11.8496 8.44807 11.7155C8.13668 11.5357 7.90945 11.2396 7.81637 10.8923C7.7233 10.545 7.772 10.1749 7.95177 9.86352ZM7.28997 14.5645L7.27187 14.5332C7.23798 14.4743 7.22884 14.4044 7.24644 14.3388C7.26404 14.2732 7.30696 14.2172 7.36577 14.1832L12.6272 11.1455C12.686 11.1116 12.756 11.1025 12.8216 11.12C12.8872 11.1376 12.9431 11.1805 12.9772 11.2393L12.9953 11.2706C13.0292 11.3295 13.0384 11.3994 13.0207 11.4651C13.0031 11.5307 12.9602 11.5866 12.9014 11.6206L7.64057 14.6583C7.6114 14.6752 7.57918 14.6862 7.54577 14.6906C7.51235 14.695 7.47839 14.6928 7.44583 14.6841C7.41327 14.6754 7.38275 14.6603 7.356 14.6398C7.32926 14.6193 7.30682 14.5937 7.28997 14.5645ZM10.3919 16.4745C10.1597 16.3404 9.9724 16.1405 9.8538 15.9C9.73521 15.6595 9.69059 15.3893 9.72559 15.1234C9.76059 14.8576 9.87363 14.608 10.0504 14.4064C10.2272 14.2048 10.4598 14.0602 10.7189 13.9908C10.9779 13.9214 11.2516 13.9303 11.5056 14.0165C11.7595 14.1027 11.9821 14.2622 12.1454 14.475C12.3086 14.6877 12.4051 14.9441 12.4227 15.2116C12.4402 15.4792 12.378 15.746 12.244 15.9782C12.0642 16.2896 11.7682 16.5169 11.4209 16.61C11.0736 16.7031 10.7033 16.6542 10.3919 16.4745Z",
    fill: "url(#paint1_linear_61_102)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.07 16.1442C11.5359 16.1442 11.9136 15.7665 11.9136 15.3006C11.9136 14.8347 11.5359 14.457 11.07 14.457C10.6041 14.457 10.2264 14.8347 10.2264 15.3006C10.2264 15.7665 10.6041 16.1442 11.07 16.1442Z",
    fill: "url(#paint2_linear_61_102)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 17.1138V8.82005C21 8.47086 20.9111 8.1274 20.7418 7.822C20.5725 7.51659 20.3283 7.25927 20.0322 7.07425L16.6543 4.55125C16.3945 4.38925 16.1018 4.28737 15.7976 4.25305C16.0837 4.45407 16.3184 4.71964 16.4828 5.02825L18.2867 9.22885C18.4644 9.56313 18.5542 9.93713 18.5477 10.3157C18.5411 10.6942 18.4383 11.0649 18.249 11.3928L13.7576 19.1722H18.9416C19.4875 19.1722 20.0111 18.9553 20.3971 18.5693C20.7831 18.1832 21 17.6597 21 17.1138Z",
    fill: "url(#paint3_linear_61_102)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_61_102",
    x1: 9.495,
    y1: 9.78223,
    x2: 9.10576,
    y2: 11.3802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E81825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C01519"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_61_102",
    x1: 13.7846,
    y1: 4.74119,
    x2: 9.81863,
    y2: 19.8859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E81825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C01519"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_61_102",
    x1: 11.4391,
    y1: 14.5414,
    x2: 11.0498,
    y2: 16.1393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E81825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C01519"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_61_102",
    x1: 18.9629,
    y1: 4.99899,
    x2: 12.9629,
    y2: 16.9563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E81825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C01519"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromos);
export default __webpack_public_path__ + "static/media/promos.3b14294a7dca7780a9610c62094ac868.svg";
export { ForwardRef as ReactComponent };